import { IProgressAuditCourseSummary } from "../../../features/progressAudit/progressAuditCoursesSlice";

// A finished course should have every lesson/topic at progress 1 - when
// it doesn't, that's exactly the kind of inconsistency the audit trail
// exists to help explain.
export const getCourseMismatchFlags = (course: IProgressAuditCourseSummary) => {
  const lessonsMismatch = course.courseFinished && course.lessonsFinishedCount !== course.lessonsCount;
  const topicsMismatch = course.courseFinished && course.topicsFinishedCount !== course.topicsCount;
  return {
    lessonsMismatch,
    topicsMismatch,
    hasMismatch: lessonsMismatch || topicsMismatch,
  };
};
